import { z } from 'zod';

export const purchaseOrderUpdateSchema = z.object({
  purchaseOrderId: z.string().min(1, 'Order number required'),
  purchaseOrderName: z.string().min(1, 'Purchase order required'),
  startDate: z.string().min(1, 'Start date required'),
  endDate: z.string().min(1, 'End date required'),
  amount: z.preprocess(
    (val) => Number(val),
    z.number().min(0.01, 'Amount must be greater than zero')
  ),
}).refine(data => {
  const startDate = new Date(data.startDate).setHours(0, 0, 0, 0);
  const endDate = new Date(data.endDate).setHours(0, 0, 0, 0);
  // Check if endDate is before startDate
  return endDate >= startDate;
}, {
  message: 'End date must be on or after the start date',
  path: ['endDate'],
});

const notesSchema = z.string().max(500, 'Max 500 characters').nullish();

export const scheduleOffRentOrderUpdateSchema = z.object({
  pickupDate: z.string().min(1, 'End date required'),
  notes: notesSchema
});
